import { ff } from '@atlassian/jira-feature-flagging';
import { REQUIRED } from '@atlassian/jira-issue-create-common-types/src/common/constants/index.tsx';
import type { IssueLink } from '@atlassian/jira-issue-field-issue-links/src/common/types.tsx';
import { mapDataToOption } from '@atlassian/jira-issue-field-issue-links/src/ui/edit/utils.tsx';
import type { Option } from '@atlassian/jira-issue-field-select-base/src/common/types.tsx';
import type { IssueLinksDefaultValueServer, FieldValue, JiraIssueLinksFieldInput } from './types';

export const transformDefaultIssueLinksValue = (
	value?: IssueLinksDefaultValueServer,
): FieldValue | undefined => {
	if (value && value.length > 0) {
		const issues: Array<Option> = [];
		value.forEach((issueLink) => {
			if (issueLink.issue) {
				issues.push({
					iconUrl: issueLink.issue.avatar?.small,
					id: issueLink.issue.issueId.toString(),
					label: issueLink.issue.key,
					value: issueLink.issue.key,
				});
			}
		});

		return ff('create-linked-issues-trigger-point-issue-view')
			? {
					linkType: mapDataToOption(value?.[0]?.relatedBy),
					issues,
					includeAttachments: undefined,
					includeLinks: undefined,
				}
			: {
					linkType: mapDataToOption(value?.[0]?.relatedBy),
					issues,
				};
	}
	return undefined;
};

export const validateIssueLinksField = (
	value?: FieldValue,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	isRequired: boolean,
): string | undefined => {
	if (isRequired) {
		if (!value) {
			return REQUIRED;
		}

		// issues can be [] when default value is set for the link type select, check the default transformer for this field
		if (value.issues.length === 0) {
			return REQUIRED;
		}
	}
	return undefined;
};

export const mutateIssueLinksField = (value: IssueLink): JiraIssueLinksFieldInput => ({
	issueLinks: {
		linkTypeName: value.linkType.value,
		linkedIssueKeys: value.issues.map((issue: Option): string => issue.value.toString()),
	},
});
